import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {AngularPageVisibilityModule} from 'angular-page-visibility';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {NgxLinkifyjsModule} from 'ngx-linkifyjs';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HeaderModule} from './modules/header/header.module';
import {CoreModule} from './modules/core/core.module';
import {SideNavModule} from './modules/side-nav/side-nav.module';
import {NewsModule} from './modules/news/news.module';
import {ArtistsModule} from './modules/artists/artists.module';
import {ScheduleService} from './services/schedule.service';
import {CoverArtModule} from './modules/coverart/coverart.module';
import {PagesModule} from './modules/pages/pages.module';
import {DataService} from './services/data.service';
import {ArchiveService} from './services/archive.service';
import {PlayerModule} from './modules/player/player.module';
import {AUDIO_SOURCE_PROVIDER} from './modules/core/services/player/audio-source';
import {SharedModule} from './modules/shared/shared.module';
import {PlayerService} from './modules/core/services/player/player.service';
import {reducers, metaReducers} from './store/reducers';
import {environment} from '../environments/environment';
import {AppEffects} from './store/effects/app.effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {SafeStylePipe} from './modules/archive/safe.pipe';
import {ImagePipe} from './modules/core/pipes/image.pipe';


import {ChatModule} from './modules/chat/chat.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    SharedModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HeaderModule,
    CoreModule,
    ChatModule,
    SideNavModule,
    NewsModule,
    ArtistsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    AngularPageVisibilityModule,
    PagesModule,
    CoverArtModule,
    NgxJsonViewerModule,
    PlayerModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      // runtimeChecks: {
      //   strictStateImmutability: true,
      //   strictActionImmutability: true,
      // }
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot([AppEffects]),
    NgxLinkifyjsModule.forRoot({
      enableHash: false,
      enableMention: false
    })
  ],
  providers: [ScheduleService, DataService, ArchiveService,
    AUDIO_SOURCE_PROVIDER, PlayerService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
